import { render, staticRenderFns } from "./ProjectModify.vue?vue&type=template&id=b2ee8aa6&scoped=true"
import script from "./ProjectModify.vue?vue&type=script&lang=js"
export * from "./ProjectModify.vue?vue&type=script&lang=js"
import style0 from "./ProjectModify.vue?vue&type=style&index=0&id=b2ee8aa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ee8aa6",
  null
  
)

export default component.exports